import { MedicalTypeId } from "@teamprevent/common/healthSurveillance";
import { Moment } from "moment";
import moment = require("moment");

export type HealthSurveillanceOutcomeRecallModel = {
    ohCaseId?: string;
    ohCaseNumber?: string;
    recallYears: number;
    recallWeeks: number;
    recallDate: Moment;
    medicalType: MedicalTypeId;
    inflight: boolean;
}

export const parseHealthSurveillanceOutcomeRecallModel = (model: HealthSurveillanceOutcomeRecallModel) =>
    ({ ...model, recallDate: moment(model.recallDate) });

export type SetRecallModel = {
    ohCaseId?: string;
    ohCaseNumber?: string;
    recallYears: number;
    recallWeeks: number;
    recallDate: Moment;
    medicalTypes: MedicalTypeId[];
    inflight: boolean;
}

export const MEDICAL_TYPE_ID = "MEDICAL_TYPE_ID";

export const getRecallDate = (outcome: HealthSurveillanceOutcomeRecallModel) => {
    return outcome.recallDate ?? moment().add(outcome.recallYears, "years").add(outcome.recallWeeks, "weeks");
};

export const isInThePastIfProvided = (date: moment.Moment) => {
    const today = moment().utc().startOf("day");
    const result = !!date && date.isValid() && date.utc().startOf("day").isBefore(today);
    return result;
};
